import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import CircleIcon from "@mui/icons-material/Circle";
import {
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Paper,
  Select,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import axios from "axios";
import { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import Pan from "../../assets/svg/PenEtat.svg";
import defaultImage from "../../assets/svg/defultImage.svg";
import deleteIcon from "../../assets/svg/delete.png";
// import "./Brands.css"
import {
  Add,
  DeleteOutline,
  Edit,
  InfoOutlined,
  Person,
} from "@mui/icons-material";
import { DataGrid } from "@mui/x-data-grid";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import dayjs from "dayjs";
import { Modal } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import DeleteModal from "../../components/Modals/DeleteModal";
import NotFound from "../../components/SharedModule/NotFound";

export default function VehiclesBrandProfile() {
  const newHost = "https://estbn.com/EstbnNew/public/api/";

  const { user } = useSelector((state) => state.auth);

  const token = user?.token;

  const newHeaders = {
    Authorization: "Bearer " + token,
  };

  const { categoryId, brandId } = useParams();

  // brand data

  const [brandInfo, setBrandInfo] = useState(null);

  const [types, setTypes] = useState([]);

  const getBrandById = async () => {
    try {
      const response = await axios.get(
        `${newHost}portal/users/vehicles/brands/${brandId}`,
        {
          headers: newHeaders,
        }
      );
      console.log(response.data.data.vehicle_brand);
      setBrandInfo(response.data.data.vehicle_brand);
      setTypes(response.data.data.types);
    } catch (error) {
      console.log(error);
    }
  };

  // create & edit model

  const [addMainCatigory, setAddMainCatigory] = useState({
    category_id: "",
    brand_id: "",
    type_id: "",
    name: "",
    start_year: "",
    end_year: "",
    status: "",
  });

  const [show, setShow] = useState(false);

  const handleShow = () => {
    setAddMainCatigory({
      category_id: "",
      brand_id: "",
      type_id: "",
      name: "",
      start_year: "",
      end_year: "",
      status: "",
    });
    setIsEditing(false);
    setEditModelId(null);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setIsEditing(false);
    setEditModelId(null);
  };

  const [isEditing, setIsEditing] = useState(false);

  const [editModelId, setEditModelId] = useState(null);

  const handleEditModel = (model) => {
    console.log(model);
    setAddMainCatigory({
      category_id: model.category?.id,
      brand_id: model.brand?.id,
      type_id: model.type?.id,
      start_year: model.start_year,
      end_year: model.end_year,
      name: model.name,
      status: model.status,
    });
    setValue("name", model.name);
    setValue("status", model.status);
    setValue("start_year", model.start_year);
    setValue("end_year", model.end_year);
    setValue("type_id", model.type?.id);
    setValue("brand_id", model.brand?.id);
    setValue("category_id", model.category?.id);
    setIsEditing(true);
    setEditModelId(model.id);
    setShow(true);
  };

  const onSubmitAddMainCatogiry = () => {
    const headers = {
      Authorization: "Bearer " + token,
    };

    const formData = new FormData();

    if (isEditing) {
      formData.append("_method", "PATCH");
    }

    formData.append("name", addMainCatigory.name);
    formData.append("status", addMainCatigory.status);
    formData.append("category_id", categoryId);
    formData.append("brand_id", brandId);
    formData.append("type_id", selectedProductId);
    formData.append("start_year", addMainCatigory.start_year);
    formData.append("end_year", addMainCatigory.end_year);

    const url = isEditing
      ? `${newHost}portal/users/vehicles/models/${editModelId}`
      : `${newHost}portal/users/vehicles/models`;

    axios
      .post(url, formData, { headers })
      .then((response) => {
        console.log(response.data);
        toast.success(response.data.message, { autoClose: 3000 });
        getBrandById();
        getModelsByTypeId();
        setShow(false);
        setIsEditing(false);
        setAddMainCatigory({
          category_id: "",
          brand_id: "",
          type_id: "",
          name: "",
          start_year: "",
          end_year: "",
          status: "",
        });
      })
      .catch((error) => {
        toast.error(error.response.data.message, { autoClose: 3000 });
      });
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors, isSubmitting },
  } = useForm();

  // delete model

  const [showDelete, setShowDelete] = useState(false);

  const handleDeleteClose = () => {
    setShowDelete(false);
    setEditModelId(null);
    handleClose();
  };

  const confirmDelete = (id) => {
    setShowDelete(true);
    setEditModelId(id);
  };

  const deleteCategory = async () => {
    try {
      let response = await axios.delete(
        `${newHost}portal/users/vehicles/models/${editModelId}`,
        {
          headers: newHeaders,
        }
      );
      toast.warning("Model Deleted successfully", { autoClose: 3000 });
      console.log(response);
      handleDeleteClose();
      getBrandById();
      getModelsByTypeId();
    } catch (error) {
      toast.error("Failed To Delete This Brand.");
      console.log(error.message);
    }
  };

  // tabs & models table

  const [products, setProducts] = useState([]);

  const getModelsByTypeId = async (typeId) => {
    try {
      const response = await axios.get(
        `${newHost}portal/users/vehicles/models?brand_id=${brandId}&type_id=${typeId}`,
        { headers: newHeaders }
      );
      setProducts(response.data.data.vehicle_models);
    } catch (error) {
      console.error("Failed to fetch models:", error);
    }
  };

  const [selectedProductId, setSelectedProductId] = useState(null);

  const handleTabChange = (event, newValue) => {
    setSelectedProductId(newValue);
    getModelsByTypeId(newValue);
  };

  const filteredProducts = useMemo(() => {
    if (!Array.isArray(products)) return [];

    return products.filter((product) => {
      const matchesProducts =
        selectedProductId === null || product.type?.id === selectedProductId;
      return matchesProducts;
    });
  }, [products, selectedProductId]);

  const rows = filteredProducts.map((product) => ({
    id: product.id,
    Name: product.name,
    Start: product.start_year,
    End: product.end_year,
    Status: product.status,
    Actions: "",
    rawData: product,
  }));

  const columns = [
    {
      field: "Name",
      headerName: "Name",
      flex: 0.9,
      minWidth: 110,
    },
    {
      field: "Start",
      headerName: "Start Year",
      flex: 0.9,
      minWidth: 110,
    },
    {
      field: "End",
      headerName: "End Year",
      flex: 0.9,
      minWidth: 110,
    },
    { field: "Status", headerName: "Status", flex: 0.8, minWidth: 100 },
    {
      field: "Actions",
      headerName: "Actions",
      flex: 0.8,
      minWidth: 80,
      sortable: false,
      filterable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        const model = params.row.rawData;
        const handleEdit = (e) => {
          e.stopPropagation();
          handleEditModel(model);
        };
        const handleDelete = (e) => {
          e.stopPropagation();
          confirmDelete(params.row.id);
        };
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
              width: "100%",
            }}
          >
            <IconButton
              style={{ width: "45%" }}
              onClick={handleEdit}
              color="default"
              size="small"
            >
              <Edit />
            </IconButton>
            <IconButton
              style={{ width: "45%" }}
              onClick={handleDelete}
              color="error"
              size="small"
            >
              <DeleteOutline />
            </IconButton>
          </div>
        );
      },
    },
  ];

  const paginationModel = { page: 0, pageSize: 10 };

  // effects

  useEffect(() => {
    getBrandById();
  }, []);

  useEffect(() => {
    if (types.length > 0) {
      const initialTypeId = types[0].id;
      setSelectedProductId(initialTypeId);
      getModelsByTypeId(initialTypeId);
    }
  }, [types]);

  return (
    <>
      {/* delete model */}
      <DeleteModal
        showDelete={showDelete}
        handleDeleteClose={handleDeleteClose}
        textMessage={" Are you sure you want to delete this model?"}
        deleteFunction={deleteCategory}
      />
      {/* create model */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header className="categories_header">
          <Modal.Title className="categories_title d-flex justify-content-between align-items-center">
            {isEditing ? "Edit Model" : "Add New Model"}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <form onSubmit={handleSubmit(onSubmitAddMainCatogiry)}>
            {/* name */}
            <div className="row">
              <div className="col-12">
                <TextField
                  className="w-100 mb-4"
                  label="Name"
                  variant="outlined"
                  {...register("name")}
                  value={addMainCatigory.name}
                  onChange={(e) => {
                    setAddMainCatigory({
                      ...addMainCatigory,
                      name: e.target.value,
                    });
                  }}
                />
                {errors.name && <p className="danger">{errors.name.message}</p>}
              </div>
            </div>
            {/* years */}
            {/* start year */}
            <div className="col-12">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    className="w-100"
                    label="Start Year"
                    views={["year"]}
                    value={
                      addMainCatigory.start_year
                        ? dayjs(`${addMainCatigory.start_year}`, "YYYY")
                        : null
                    }
                    onChange={(date) => {
                      setAddMainCatigory((prev) => ({
                        ...prev,
                        start_year: date ? dayjs(date).format("YYYY") : null,
                      }));
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
            {/* end year */}
            <div className="col-12">
              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DemoContainer components={["DatePicker"]}>
                  <DatePicker
                    className="w-100"
                    label="End Year"
                    views={["year"]}
                    value={
                      addMainCatigory.end_year
                        ? dayjs(`${addMainCatigory.end_year}`, "YYYY")
                        : null
                    }
                    onChange={(date) => {
                      setAddMainCatigory((prev) => ({
                        ...prev,
                        end_year: date ? dayjs(date).format("YYYY") : null,
                      }));
                    }}
                  />
                </DemoContainer>
              </LocalizationProvider>
            </div>
            {/* status */}
            <div className="row my-2">
              <div className="col-12">
                <FormControl className="w-100 mb-4" variant="outlined">
                  <InputLabel id="status-label">Status</InputLabel>
                  <Select
                    labelId="status-label"
                    label="Status"
                    {...register("status")}
                    value={addMainCatigory.status}
                    onChange={(e) => {
                      setAddMainCatigory({
                        ...addMainCatigory,
                        status: e.target.value,
                      });
                    }}
                  >
                    <MenuItem className="custom-menu-item" value="active">
                      Active
                    </MenuItem>
                    <MenuItem className="custom-menu-item" value="inactive">
                      Inactive
                    </MenuItem>
                  </Select>
                </FormControl>
                {errors.status && (
                  <p className="danger">{errors.status.message}</p>
                )}
              </div>
            </div>
            {/* footer */}
            <div className="categories_foterAddModel">
              <button
                type="button"
                className="categories_closAddModal"
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isSubmitting}
                className="categories_saveAddModeal"
              >
                Save
              </button>
            </div>
          </form>
        </Modal.Body>
      </Modal>
      {/* brand data */}
      <div className="min-vh-100 p-3">
        {/* profile head */}
        <div className="row align-items-center mb-3">
          <div className="col-12 col-lg-4 col-xl-3 mb-2 mb-md-0">
            <h5 className="fw-semibold">Brand Profile</h5>
          </div>
          {/* tabs and activation  */}
          <div className="col-12 col-lg-8 col-xl-9">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-start">
              {/* Tabs Section */}
              <div
                className="bg-light rounded-3 w-100 d-flex justify-content-center align-items-center"
                style={{
                  maxWidth: "100%",
                  WebkitOverflowScrolling: "touch",
                }}
              >
                <Tabs
                  value={selectedProductId}
                  onChange={handleTabChange}
                  variant="scrollable"
                  scrollButtons="auto"
                  allowScrollButtonsMobile
                  aria-label="brand category tabs"
                  slotProps={{
                    indicator: {
                      sx: { backgroundColor: "darkgray" },
                    },
                  }}
                  sx={{
                    minWidth: "365px",
                    ".MuiTabs-flexContainer": {
                      maxWidth: "100%",
                    },
                    ".MuiTab-root": {
                      minWidth: "fit-content",
                      padding: "6px 12px",
                      fontSize: "14px",
                    },
                  }}
                >
                  {types.map((type) => (
                    <Tab
                      key={type.id}
                      label={
                        <span className="tab-label">
                          {type.name}
                          <span className="circle">{type.models_count}</span>
                        </span>
                      }
                      value={type.id}
                    />
                  ))}
                </Tabs>
              </div>
            </div>
          </div>
        </div>
        {/* Profile Body */}
        <div className="row gy-4">
          {/* Side Card */}
          <div className="col-12 col-lg-4 col-xl-3">
            <div className="border border-2 rounded-3 p-3 h-100">
              <div className="bg-light rounded-4 text-center px-3 py-2 mb-3">
                <div className="supplier_imgHulder">
                  <img
                    src={
                      brandInfo?.logo_path
                        ? `https://estbn.com/EstbnNew/public${brandInfo?.logo_path}`
                        : defaultImage
                    }
                    alt="Profile"
                    className="img-fluid"
                  />
                </div>
              </div>
              <div className="d-flex justify-content-between align-items-center mt-4">
                <h5 className="fw-bold">{brandInfo?.name}</h5>
                <div className="d-flex gap-2">
                  <div
                    className="categoryImgCard cursor"
                    // onClick={() => handleEditCategory(brandInfo)}
                  >
                    <img src={Pan} alt="Edit" />
                  </div>
                  <div
                    className="categoryImgCard cursor"
                    // onClick={confirmSideDelete}
                  >
                    <img src={deleteIcon} alt="Delete" />
                  </div>
                </div>
              </div>
              <div className="stuffprofileinfo_supplierProfile">
                <div className="agentInfo-Supp">Brand Info</div>
                <div className="d-flex gap-2 align-items-center my-1">
                  <Person fontSize="small" />
                  <p className="fw-semibold m-0">
                    Created By {brandInfo?.creator?.name}
                  </p>
                </div>
                <div className="d-flex gap-2 align-items-center my-1">
                  <CalendarTodayIcon fontSize="small" />
                  <p className="fw-semibold m-0">
                    {`Created On ${new Date(
                      brandInfo?.created_at
                    ).toLocaleDateString()}`}
                  </p>
                </div>
                <div className="d-flex gap-2 align-items-center my-1">
                  <CircleIcon
                    fontSize="small"
                    color={
                      brandInfo?.status === "active" ? "success" : "disabled"
                    }
                  />
                  <p className="fw-semibold m-0">{brandInfo?.status_label}</p>
                </div>
                <div className="d-flex gap-2 align-items-start my-1">
                  <InfoOutlined fontSize="small" className=" mt-1" />
                  <p className="categoryInfo my-0">{brandInfo?.description}</p>
                </div>
              </div>
            </div>
          </div>
          {/* Table Section */}
          <div className="col-12 col-lg-8 col-xl-9 ">
            <div className="border border-2 rounded-3 p-3">
              <div className=" d-flex justify-content-between align-items-center my-2">
                <p className="my-0 fs-5 fw-bold">Models</p>
                <button
                  className=" btn border border-1"
                  onClick={() => handleShow()}
                >
                  <Add className="me-2" />
                  New Model
                </button>
              </div>
              {filteredProducts && filteredProducts.length > 0 ? (
                <div className="scrollable-table-wrapper">
                  <div>
                    <Paper sx={{ width: "100%" }}>
                      <DataGrid
                        rows={rows}
                        columns={columns}
                        initialState={{ pagination: { paginationModel } }}
                        pageSizeOptions={[5, 10]}
                        checkboxSelection
                        sx={{ border: 0 }}
                        slotProps={{
                          pagination: {
                            sx: {
                              justifyContent: "center",
                              display: "flex",
                              alignItems: "center",
                            },
                          },
                        }}
                      />
                    </Paper>
                  </div>
                </div>
              ) : (
                <div
                  className="d-flex justify-content-center align-items-center w-100"
                  style={{ minHeight: "300px" }}
                >
                  <NotFound paragraphText="No Models yet. All your Models will appear here once you get started." />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
